<script>
  import { auth, db } from "../etc/firebase.js"
  import "materialize-css"
  import { currentUser } from "../etc/store.js"
  import Note from "./Note.svelte"

  document.addEventListener("DOMContentLoaded", function () {
    var modals = document.querySelectorAll(".modal")
    M.Modal.init(modals)

    var items = document.querySelectorAll(".collapsible")
    M.Collapsible.init(items)
  })

  let notes = []
  let title = ""
  let content = ""
  let publicNote = false

  // add note
  const addNote = () => {
    const createdDT = new Date().getTime()
    db.collection("notes").add({
      createdDT,
      title,
      publicNote,
      content,
    })

    const modal = document.querySelector("#modal-note")
    M.Modal.getInstance(modal).close()

    title = ""
    content = ""
    publicNote = false
  }

  // get notes data from Firebase db
  // db.collection("notes")
  //   .orderBy("createdDT")
  //   .onSnapshot((data) => {
  //     console.log(data.docs)
  //     notes = data.docs
  //   })

  // Listen for auth status change
  auth.onAuthStateChanged((user) => {
    if (user) {
      console.log(user.email + " just logged in!")
      currentUser.email = user.email

      // get notes data from Firebase db
      db.collection("notes")
        .orderBy("createdDT")
        .onSnapshot((data) => {
          console.log(data.docs)
          notes = data.docs
        })
    } else {
      //notes = []

      currentUser.email = ""
      currentUser.loggedIn = false
      console.log(currentUser.email + " just logged out!")
    }
  })
</script>

<main>
  <h3>Notes</h3>

  {#if currentUser.email == ""}
    <p>Please log in to view Notes.</p>
  {:else}
    <p>Logged in as {currentUser.email}</p>
    <button
      class="btn yellow darken-2 z-depth-0 modal-trigger"
      data-target="modal-note">Add Note</button
    >
  {/if}

  <!-- CREATE GUIDE MODAL -->
  <div id="modal-note" class="modal">
    <div class="modal-content">
      <h4>Create Note</h4>
      <br />
      <form id="create-form" on:submit|preventDefault={addNote}>
        <div class="input-field">
          <input type="text" id="title" bind:value={title} required />
          <label for="title">Note Title</label>
        </div>
        <div class="input-field">
          <p>
            <label>
              <input type="checkbox" bind:checked={publicNote} />
              <span>For Public Viewing</span>
            </label>
          </p>
          <br />
        </div>
        <div class="input-field">
          <textarea
            id="content"
            class="materialize-textarea"
            bind:value={content}
            required
          />
          <label for="content">Note Content</label>
        </div>
        <button class="btn yellow darken-2 z-depth-0">Create</button>
      </form>
    </div>
  </div>

  <!-- NOTES LIST -->
  <div class="container" style="margin-top: 40px;">
    <ul class="collapsible z-depth-0 notes" style="border: none;">
      {#each notes as note}
        {#if currentUser.loggedIn | note.publicNote}
          <Note id={note.id} note={note.data()} />
        {/if}
      {/each}
    </ul>
  </div>
</main>
